import List from 'containers/NotificationsAndAlerts/List';

export default { List };
